import { useEffect, useState } from "react";
import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { KeyboardDatePicker } from "@material-ui/pickers/DatePicker";

import { moneyFormater } from "../../../../utilities/formaters";
import RefreshButton from "../../../../shared/ui/Refresh.Button";

import Link from "../../../../shared/ui/Link.Component";
import { accountBalanceConnector } from "../../../../services/menu/dashboard/account.balance.connector";
import SavelendAccountBalance from "./parts/Savelend.Account.Balance";
import LoanstepAccountBalance from "./parts/Loanstep.Account.Balance";

import moment from "moment";

const DashboardAccountBalanceComponent = (props) => {
  const [date, setDate] = useState(null);
  const currency = props.currency;

  useEffect(() => {
    if (!props.accountBalance[currency].fetched) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshBtnClick = () => {
    fetchData();
  };

  const fetchData = () => {
    const dateToFetch =
      date === null ? null : moment(date).format("YYYY-MM-DD");
    props.fetchAccountBalanceForDay(dateToFetch, currency);
    if (currency === "SEK") props.fetchLsAccountBalances(dateToFetch, currency);
    props.fetchOriginatorBalances(dateToFetch, currency);
    props.fetchTrustlyAccountBalance(currency);
  };

  const handleChangeDate = (value) => setDate(value);

  const balanceFetched =
    props.accountBalance[currency].fetched &&
    !props.accountBalance[currency].fetching;
  const originatorsBalanceFetched =
    props.accountBalance[currency].originatorsFetched &&
    !props.accountBalance[currency].originatorsFetching;
  const lsBalanceFetched =
    (props.accountBalance[currency].lsFetched &&
      !props.accountBalance[currency].lsFetching) ||
    currency !== "SEK";
  const trustlyBalanceFetched =
    props.accountBalance[currency].trustlyFetched &&
    !props.accountBalance[currency].trustlyFetching;

  if (
    balanceFetched &&
    originatorsBalanceFetched &&
    lsBalanceFetched &&
    trustlyBalanceFetched
  ) {
    let balance = props.accountBalance[currency].data;

    let slTax = balance.SavelendTax.Amount;
    let slFees = balance.SavelendFees.Amount;
    let invRecon = balance.InvestorRecon.Amount;
    let invRes = balance.InvestorsReserved.Amount;
    let invAvail = balance.InvestorsAvailable.Amount;
    let origRes = balance.OriginatorInvestorsReserved.Amount;
    let origAvail = balance.OriginatorInvestorsAvailable.Amount;
    let trustlyRecon = balance.TrustlyRecon.Amount;
    let swishRecon = balance.SwishRecon.Amount;

    let sblOrig = props.accountBalance[currency].originatorsData.reduce(
      (t, o) => {
        return t + (o.IsSblsOwnBalance ? o.Balance : 0);
      },
      0,
    );

    let total =
      slTax +
      slFees +
      invRecon +
      trustlyRecon +
      swishRecon +
      invRes +
      invAvail +
      origAvail +
      origRes;
    let sblTotal = slFees + sblOrig;

    // Loanstep and Trustly data is only provided for SEK currency
    let lsData = null;
    if (currency === "SEK") {
      lsData = props.accountBalance[currency].lsData;

      let lsCash = lsData.LoanstepCash.Amount;
      let lsFees = lsData.LoanstepFees.Amount;
      let borRecon = lsData.BorrowerRecon.Amount;
      let borDep = lsData.BorrowerDepots.Amount;

      total += lsCash + lsFees + borRecon + borDep;
      sblTotal += lsCash;
    }

    return (
      <div style={{ margin: "5px" }}>
        <div style={{ textAlign: "right" }}>
          <KeyboardDatePicker
            inputVariant="outlined"
            format="YYYY-MM-DD"
            className="small-datepicker"
            label="Show Balance For"
            onChange={handleChangeDate}
            value={date}
          />
        </div>
        <RefreshButton onRefreshClick={refreshBtnClick} />
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="In the bank?" />
          <CardContent>
            <b>Total:</b> {moneyFormater(Math.floor(total * 100) / 100)}{" "}
            {currency}
            <br />
            <b>SBL Total:</b> {moneyFormater(Math.floor(sblTotal * 100) / 100)}{" "}
            {currency}
            <br />
          </CardContent>
        </Card>
        <br /> <br />
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="Trustly account balances" />
          <CardContent>
            <div>
              <strong>Cash</strong>:{" "}
              {moneyFormater(
                Math.floor(props.accountBalance[currency].trustlyData * 100) /
                  100,
              )}{" "}
              {currency}
              <br />
            </div>
            Current balance at Trustly
            <br />
            (does not support time travel)
          </CardContent>
        </Card>
        <br /> <br />
        <SavelendAccountBalance currency={currency} />
        {currency === "SEK" && <LoanstepAccountBalance currency={currency} />}
        <br />
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="Originator balance breakdown" />
          <CardContent>
            {props.accountBalance[currency].originatorsData.map((o, index) => {
              return (
                <div key={`originators-${index}`}>
                  <div>
                    <Link
                      toState={"userOverview"}
                      parameters={["identity", o.InvestorId]}
                    >
                      <b>{o.Name} </b>
                    </Link>{" "}
                    {moneyFormater(o.Balance)} {currency}
                  </div>
                </div>
              );
            })}
          </CardContent>
        </Card>
      </div>
    );
  }
  return <div>Loading</div>;
};

export default compose(accountBalanceConnector)(
  DashboardAccountBalanceComponent,
);
